import { render, staticRenderFns } from "./MyTeacherFinalistsForm.vue?vue&type=template&id=35152130&"
import script from "./MyTeacherFinalistsForm.vue?vue&type=script&lang=js&"
export * from "./MyTeacherFinalistsForm.vue?vue&type=script&lang=js&"
import style0 from "./MyTeacherFinalistsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports